<div class="order-details">
  @if (orderDetails) {
    <div class="order-details__header">
      <div class="column">
        <div class="base-info">
          <p>
            <span class="base-info__label" [attr.data-test]="'label-purchaseOrder'">
              {{ 'spare-part-item-details.purchase-order' | translate }}:
            </span>
            <span class="base-info__text" [attr.data-test]="'desc-purchaseOrder'">
              {{ orderDetails.attributes?.sapPoNumber }}
            </span>
          </p>
          @if (isEligibleForReturn) {
            <p>
              <span class="base-info__label" [attr.data-test]="'label-returnOrderNumber'">
                {{ 'spare-part-item-details.return-order-number' | translate }}:
              </span>
              <span class="base-info__text" [attr.data-test]="'desc-returnOrderNumber'">
                {{ orderDetails.attributes.sapDetails?.returnAuthorizationNumber }}
              </span>
            </p>
          }
        </div>
        @if (isEligibleForReturn) {
          <a [attr.data-test]="'link-downloadReturnDocument'"
             (click)="downloadReturnDocument()">
            <span class="icon-arrow-right"></span>
            <span>
              {{ 'spare-part-item-details.download-return-doc' | translate }}
            </span>
          </a>
        }
      </div>
      <div class="column">
        <a (click)="generateOrderDetailPdf()"
           [attr.data-test]="'link-pdfExport'">
          @if (!pdfGenerationInProgress) {
            <span class="icon-arrow-right"></span>
            <span>
              {{ 'spare-part-item-details.pdf-export' | translate }}
            </span>
          } @else {
            <div class="btn-spinner">
              <div class="loading-animation"></div>
            </div>
          }
        </a>
        @if (!isBusinessPartner) {
          <a [ngClass]="{'disabled': isAddToCartDisabled() && !isAddToCartInProgress()}"
             [attr.data-test]="'link-reorderAllItems'"
             (click)="addItemsToCart(orderDetails.attributes?.items)">
            @if (!isAddToCartInProgress()) {
              <span class="icon-arrow-right"></span>
              <span>
                {{ 'spare-part-item-details.reorder-all-items' | translate }}
              </span>
            } @else {
              <div class="btn-spinner">
                <div class="loading-animation"></div>
              </div>
            }
          </a>
        }
        <a [attr.data-test]="'link-showOrderDetails'" (click)="redirectToOrderDetails(orderDetails.id)">
          <span class="icon-arrow-right"></span>
          <span>
            {{ 'spare-part-item-details.show-order-details' | translate }}
          </span>
        </a>
      </div>
    </div>
    <span class="submit-return-doc">
      @if (isEligibleForReturn && isReturnableDocumentEmailLinkEnable) {
       <a class="submit-return-doc__link"
          [attr.data-test]="'link-submitReturnDocument'"
          href="mailto: {{ 'service-purchase-activity.return-document-recipient-email' | translate }}
         ?Subject=Return Document {{ orderDetails.attributes.sapDetails.returnAuthorizationNumber }}">
         <span class="icon-arrow-right"></span> {{ 'service-purchase-activity.submit-email-document' | translate }}
       </a>
       <a class="submit-return-doc__msg">
         <div>
           {{ 'service-purchase-activity.submit-return-document-text-line1' | translate }}<br>
           {{ 'service-purchase-activity.submit-return-document-text-line2' | translate }}
         </div>
       </a>
      }
    </span>
    <div class="address-information">
      <p class="address-information__title">{{ 'spare-part-item-details.address-info' | translate }}:</p>
      <div class="address-information__container">
        <div class="ordered-by">
          <span class="greyed-out" [attr.data-test]="'label-orderedBy'">
            {{ 'spare-part-item-details.ordered-by' | translate }}:
          </span>
          <span [attr.data-test]="'label-customerName'">
            {{ orderDetails.attributes.pointOfContact?.firstName }} {{ orderDetails.attributes.pointOfContact?.lastName }}
          </span>
          <span [attr.data-test]="'label-customerEmail'">
            {{ orderDetails.attributes.pointOfContact?.email }}
          </span>
          <span [attr.data-test]="'label-customerPhone'">
            {{ orderDetails.attributes.pointOfContact?.phone }}
          </span>
        </div>
        @for (address of addresses; track address.type) {
          <div class="address" [attr.data-test]="'div-' + address.type">
            <span class="greyed-out" [attr.data-test]="'label-address'">
              {{ 'spare-part-item-details.' + address.translationKey | translate }}:
            </span>
            @if (address.type === 'shippingAddress') {
              <span [attr.data-test]="'desc-attentionTo'">
                {{ formatIfMissingValue(orderDetails.attributes.pointOfContact?.attentionTo) }}
              </span>
            }
            <span [attr.data-test]="'desc-addressName'">
              @if (!orderDetails.attributes[address.type]?.isCustom
              && orderDetails.attributes[address.type]?.sapId) {
                {{ orderDetails.attributes[address.type]?.sapId }} -
              }
              {{ formatIfMissingValue(orderDetails.attributes[address.type]?.company) }}
            </span>
            <span [attr.data-test]="'desc-addressStreet'">
              {{ formatIfMissingValue(orderDetails.attributes[address.type]?.address1) }}
            </span>
            <span [attr.data-test]="'desc-addressCity'">
              {{ formatIfMissingValue(orderDetails.attributes[address.type]?.city) +
                (orderDetails.attributes[address.type]?.state ? (', ' + orderDetails.attributes[address.type]?.state) : '')
                + ' ' + formatIfMissingValue(orderDetails.attributes[address.type]?.zipCode)
              }}
            </span>
          </div>
        }
      </div>
      @if (isBusinessPartner) {
        <div class="customer-information__container">
          <div class="customer">
           <span class="greyed-out" [attr.data-test]="'label-customer'">
              {{ 'purchase-activity.customer' | translate }}
            </span>
            <div [attr.data-test]="'desc-customerBusinessUnit'">
              {{ orderDetails.attributes?.systemDetails?.shipToAddress?.name }}
            </div>
          </div>
        </div>
      }
    </div>
    <div class="ordered-items">
      <p class="ordered-items__title">{{ 'spare-part-item-details.ordered-items' | translate }}:</p>
      @for (item of orderDetails.attributes?.items; track item.id ?? item.sku ?? item.materialNumber) {
        <div class="product__wrapper" [attr.data-test]="'order-item-' + item.name">
          <div class="product__image">
            <img [src]="item.metadata?.image" [alt]="item.name" [attr.data-test]="'img-productImage'">
          </div>
          <div class="product__details">
            <div class="product__header">
              <h5 class="product__name" [attr.data-test]="'desc-productName'">
                <a [routerLink]="['/product/', `A_${item.materialNumber}`]">{{ item.name }}</a>
              </h5>
              @if ((isProductDiscontinuedStatusEnabled$ | async) && item.isDiscontinued) {
                <span class="label discontinued-item"
                      [attr.data-test]="'label-discontinuedItem'">
                  {{ 'spare-parts.discontinued-item' | translate }}
                </span>
              }
              @if (item.sapDetails?.exchangeableItem) {
                <span class="label item-exchange-material">
                  {{ 'spare-parts.exchangeable-item' | translate }}
                </span>
              }
              @if (item.heavyweight) {
                <span class="label heavyweight-item">
                  {{ 'spare-parts.heavyweight-item' | translate }}
                </span>
              }
            </div>
            <p class="product__materialNumber" [attr.data-test]="'desc-productMaterialNumber'">
              {{ item.materialNumber }}
            </p>
            <div class="product__footer">
              <div class="product__info">
                <div class="display-flex flex-column product__info--label">
                  <span [attr.data-test]="'label-quantity'">
                    {{ 'spare-part-item-details.quantity' | translate }}:
                  </span>
                  <span [attr.data-test]="'label-price'">
                    {{ 'spare-part-item-details.total-price' | translate }}:
                  </span>
                </div>
                <div class="display-flex flex-column product__info--value">
                  <span class="product__qty" [attr.data-test]="'desc-quantity'">
                  {{ item.quantity }}
                  </span>
                  <span class="product__price" [attr.data-test]="'desc-price'">
                  {{ item.sumPrice | currency: orderDetails.attributes?.currencyIsoCode }}
                  </span>
                </div>
              </div>
              @if (!isBusinessPartner) {
                <div class="product__btn">
                  <button
                      class="button button--small button--primary buy-again-button"
                      appDebounceClick
                      (debounceClick)="addItemToCart(item)"
                      [disabled]="isAddToCartDisabled()"
                      [attr.data-test]="'button-buyAgain'">
                    <span class="buy-again__icon icon-replay"></span>
                    {{ 'spare-part-item-details.buy-again' | translate }}
                  </button>
                </div>
              }
            </div>
            <div class="max-width-50">
              @if (item?.materialMasterNumbers) {
                <app-advanced-product-information
                    [orderItem]="item"
                    [isEditingEnabled]="false">
                </app-advanced-product-information>
              }
            </div>
          </div>
        </div>
      }
    </div>
  }
</div>
